import getAmount from 'components/Layout/Mining/MiningCalculator/utils/getAmount';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

interface Props {
  totalProfit: number;
  isCalculatorModifiedByUser: boolean;
}

const TotalCost = (props: Props) => {
  const { totalProfit, isCalculatorModifiedByUser } = props;

  const { t } = useTranslation();

  const totalProfitClassNames = classNames('total-cost__profit', {
    'total-cost__profit--muted':
      totalProfit === 0 && !isCalculatorModifiedByUser,
    'total-cost__profit--danger': totalProfit < 0,
  });

  return (
    <div className="total-cost">
      <h3 className="total-cost__header">{t('miningCalculator.sum.title')}</h3>
      <div className={totalProfitClassNames}>
        <span>
          {getAmount({
            value: totalProfit,
            isModifiedByUser: isCalculatorModifiedByUser,
            period: 'daily',
          })}
        </span>
        <span className="total-cost__profit-unit">{` / ${t(
          'miningCalculator.sum.daily',
        )}`}</span>
      </div>
      <div className={totalProfitClassNames}>
        <span>
          {getAmount({
            value: totalProfit,
            isModifiedByUser: isCalculatorModifiedByUser,
            period: 'monthly',
          })}
        </span>
        <span className="total-cost__profit-unit">{` / ${t(
          'miningCalculator.sum.monthly',
        )}`}</span>
      </div>
    </div>
  );
};

export default TotalCost;
